<template>
    <portal :to="portalType">
        <div :key="_uid" class="modal">
            <div v-clickaway="handleClickaway" :class="modalBodyClass">
                <button v-if="showCloseButton" class="modal__close" type="button" @click="handleEscape">
                    <common-icon name="close" size="small"></common-icon>
                </button>

                <h4 v-if="heading" class="modal__heading">
                    {{ heading }}
                </h4>

                <slot></slot>
            </div>
            <portal-target v-if="!showAsInnerModal" name="inner-modals" @change="portalTargetChanged"></portal-target>
        </div>
    </portal>
</template>

<script>
    import EscapeActionsMixin from 'mixins/EscapeActionsMixin'
    import debounce from 'lodash/debounce'
    import config from '../../config'

    export default {
        mixins: [EscapeActionsMixin],

        props: {
            heading: { type: String, default: null },
            width: { type: String, default: 'base' },
            height: { type: String, default: null },
            showAsInnerModal: { type: Boolean, default: false },
            showCloseButton: { type: Boolean, default: true },
            closeOnClickAway: { type: Boolean, default: true },
        },

        data() {
            return {
                hasInnerPortal: false,
            }
        },

        computed: {
            modalBodyClass() {
                return {
                    modal__body: true,
                    [`modal__body--width-${this.width}`]: this.width,
                    [`modal__body--height-${this.height}`]: this.height,
                }
            },

            portalType() {
                return this.showAsInnerModal ? 'inner-modals' : 'modals'
            },
        },

        methods: {
            handleClickaway(event) {
                if (this.closeOnClickAway) {
                    this.handleEscape(event)
                }
            },

            handleEscape(event) {
                event.stopPropagation()
                if (!this.hasInnerPortal) {
                    this.emitEvent({ name: 'close' })
                }
            },

            portalTargetChanged(event) {
                if (this.hasInnerPortal) {
                    this.delayedPortalChange(this, event)
                    return
                }
                this.hasInnerPortal = event
            },

            delayedPortalChange: debounce(function (data, event) {
                data.hasInnerPortal = event
            }, config.DEBOUNCE.DEFAULT),
        },
    }
</script>
